import { Module } from 'vuex';
import { defaultEstimateData } from '@/features/common/raw';
import { EstimateStateType } from '../types';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const estimate: Module<EstimateStateType, any> = {
  state: {
    estimateData: JSON.parse(JSON.stringify(defaultEstimateData)),
  },
  mutations,
  getters,
  actions,
};

export default estimate;
